<template>
  <div class="order-form-page">
    <div class="form-content">
      <!-- 学员信息 -->
      <div class="form-card">
        <div class="card-header">
          <span class="card-icon"><van-icon name="user-o" size="16" color="#1989fa" /></span>
          <span class="card-title">学员信息</span>
          <van-button size="small" type="primary" plain @click="showStudentCreate = true">新增学员</van-button>
        </div>
        <div class="card-body">
          <div class="select-row" @click="showStudentPicker = true">
            <span class="select-label required">学员</span>
            <span class="select-value" :class="{ placeholder: !form.studentName }">
              {{ form.studentName || '请选择学员' }}
            </span>
            <van-icon name="arrow" size="14" color="#c8c9cc" />
          </div>
          <div class="student-tags" v-if="checkedStudent">
            <van-tag size="medium" plain type="primary">{{ getDictLabel(grade_list, checkedStudent.grade) }}</van-tag>
            <van-tag size="medium" plain type="success">{{ checkedStudent.schoolName }}</van-tag>
            <van-tag size="medium" plain>{{ checkedStudent.studentNo }}</van-tag>
            <span class="balance" v-if="checkedStudent.accountBalance > 0">
              余额 ¥{{ checkedStudent.accountBalance }}
            </span>
          </div>
        </div>
      </div>

      <!-- 课程/班级信息：博尔思先选课程，博思班课先选班级 -->
      <div class="form-card">
        <div class="card-header">
          <span class="card-icon"><van-icon name="orders-o" size="16" color="#1989fa" /></span>
          <span class="card-title required">{{ isBosi ? '班级信息' : '课程信息' }}</span>
          <van-button size="small" type="primary" plain @click="isBosi ? (showSchedulePicker = true) : (showCoursePicker = true)">
            {{ isBosi ? '添加班级' : '添加课程' }}
          </van-button>
        </div>
        <div class="card-body">
          <div v-if="!form.studyCourseList?.length" class="empty-state">
            <van-icon name="orders-o" size="32" color="#dcdee0" />
            <span>{{ isBosi ? '请添加班级' : '请添加课程' }}</span>
          </div>
          <div
            v-for="(course, idx) in form.studyCourseList"
            :key="course.scheduleId || course.courseId || idx"
            class="course-card"
          >
            <div class="course-card-header">
              <span class="course-name">{{ isBosi ? (course.scheduleName || course.courseName) : course.courseName }}</span>
              <van-icon name="cross" size="16" color="#c8c9cc" @click="removeCourse(idx)" />
            </div>
            <!-- <div v-if="isBosi" class="schedule-info">
              <span>课程：{{ course.courseName }}</span>
              <span v-if="course.classNumber">班号：{{ safeDictLabel(class_number, course.classNumber) }}</span>
              <span v-if="course.periodsClass">期数：{{ safeDictLabel(periods_class, course.periodsClass) }}</span>
              <span v-if="course.level">层次：{{ safeDictLabel(class_level, course.level) }}</span>
            </div> -->

            <!-- 缴费类型：胶囊按钮组，字典 order_type -->
            <div class="paytype-label required">缴费类型</div>
            <div class="payment-type-tabs">
              <span
                v-for="dict in order_type"
                :key="dict.dictValue"
                class="payment-tab"
                :class="{ active: course.paymentType === Number(dict.dictValue) }"
                @click="onPaymentTypeTabClick(course, Number(dict.dictValue))"
              >{{ dict.dictLabel }}</span>
            </div>

            <div class="course-info-grid">
              <div class="info-item">
                <span class="info-label">单价</span>
                <span class="info-value">¥{{ course.totalPrice }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">购买数量</span>
                <van-stepper v-model="course.buyNumbers" :min="1" integer @change="onBuyNumbersChange(course)" />
              </div>
              <div class="info-item">
                <span class="info-label">购买课时</span>
                <span class="info-value">{{ course.buyClassHourCount }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">赠送课时</span>
                <van-stepper v-model="course.giftClassHourCount" :min="0" integer :disabled="!course.editGiftClassHourCount" @change="onGiftChange(course)" />
              </div>
              <div class="info-item">
                <span class="info-label">折扣(%)</span>
                <van-stepper v-model="course.discount" :min="0" :max="100" :disabled="!editDiscount" @change="onDiscountChange(course)" />
              </div>
              <div class="info-item">
                <span class="info-label">减免金额</span>
                <van-stepper v-model="course.reductionAmount" :min="0" step="10" :precision="2" :disabled="!course.editReductionAmount" @change="onReductionChange(course)" />
              </div>
            </div>

            <div class="course-amount-row">
              <div class="amount-col">
                <span class="amount-label">课程总金额</span>
                <span class="amount-value">¥{{ course.coursePay }}</span>
              </div>
              <div class="amount-col amount-highlight">
                <span class="amount-label">优惠后金额</span>
                <span class="amount-value">¥{{ course.realPrice }}</span>
              </div>
            </div>

            <!-- 续费/扩科（非班课）：续费教师与续费金额（对齐PC端），置于课程信息与金额之后 -->
            <div class="renewal-section" v-if="isRenewalEditable(course)">
              <div class="select-row" @click="openTeacherPicker(idx)">
                <span class="select-label">续费教师</span>
                <span class="select-value" :class="{ placeholder: !course.teacherId }">
                  {{ getTeacherName(course.teacherId) || '请选择续费教师' }}
                </span>
                <van-icon name="arrow" size="14" color="#c8c9cc" />
              </div>
              <div class="renewal-amount-row">
                <span class="select-label">续费金额</span>
                <van-stepper
                  v-model="course.commissionAmount"
                  :min="0"
                  :max="course.realPrice"
                  :precision="2"
                  step="10"
                  @change="handleCommissionAmountChange(course)"
                />
              </div>
            </div>
          </div>
          <div class="amount-summary" v-if="form.studyCourseList?.length">
            <div class="summary-item">
              <span>总课时</span>
              <span class="summary-val">{{ form.classHourTotal || 0 }}</span>
            </div>
            <div class="summary-item">
              <span>课程总金额</span>
              <span class="summary-val">¥{{ form.courseAmount || 0 }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 营销政策 -->
      <div class="form-card" v-if="!form.isSpecialDiscount">
        <div class="card-header">
          <span class="card-icon"><van-icon name="gift-o" size="16" color="#1989fa" /></span>
          <span class="card-title">营销政策</span>
        </div>
        <div class="card-body">
          <div class="policy-group" v-if="discountAvailableMarketing.length">
            <div class="policy-label">满折</div>
            <div class="policy-list">
              <div
                v-for="card in discountAvailableMarketing"
                :key="card.settingId"
                :class="['policy-chip', { active: isCardSelected(form.selectDiscountCard, card) }]"
                @click="handleDiscountCardSelect(card)"
              >
                <div class="chip-name">{{ card.activityName }}</div>
                <div class="chip-desc">满{{ card.satisfy }}课时{{ card.gift }}折</div>
              </div>
            </div>
          </div>
          <div class="policy-group" v-if="reductionAvailableMarketing.length">
            <div class="policy-label">满减</div>
            <div class="policy-list">
              <div
                v-for="card in reductionAvailableMarketing"
                :key="card.settingId"
                :class="['policy-chip', { active: isCardSelected(form.selectReductionCard, card) }]"
                @click="handleReductionCardSelect(card)"
              >
                <div class="chip-name">{{ card.activityName }}</div>
                <div class="chip-desc">满{{ card.satisfy }}课时减免{{ card.gift }}元</div>
              </div>
            </div>
          </div>
          <div class="policy-group" v-if="giftAvailableMarketing.length">
            <div class="policy-label">赠送课时</div>
            <div class="policy-list">
              <div
                v-for="card in giftAvailableMarketing"
                :key="card.settingId"
                :class="['policy-chip', { active: isCardSelected(form.selectGiftCard, card) }]"
                @click="handleGiftCardSelect(card)"
              >
                <div class="chip-name">{{ card.activityName }}</div>
                <div class="chip-desc">满{{ card.satisfy }}课时送{{ card.gift }}课时</div>
              </div>
            </div>
          </div>
          <div v-if="!discountAvailableMarketing.length && !reductionAvailableMarketing.length && !giftAvailableMarketing.length" class="empty-state small">
            <span>暂无可用营销政策</span>
          </div>
        </div>
      </div>

      <!-- 优惠券 -->
      <div class="form-card" v-if="voucherList.length">
        <div class="card-header">
          <span class="card-icon"><van-icon name="coupon" size="16" color="#1989fa" /></span>
          <span class="card-title">优惠券</span>
        </div>
        <div class="card-body">
          <div class="select-row" @click="showVoucherPicker = true">
            <span class="select-label">选择优惠券</span>
            <span class="select-value" :class="{ placeholder: !form.selectVoucher?.length }">
              {{ form.selectVoucher?.length ? `已选${form.selectVoucher.length}张` : '请选择优惠券' }}
            </span>
            <van-icon name="arrow" size="14" color="#c8c9cc" />
          </div>
        </div>
      </div>

      <!-- 特批优惠 -->
      <div class="form-card">
        <div class="card-header">
          <span class="card-icon"><van-icon name="star-o" size="16" color="#1989fa" /></span>
          <span class="card-title">特批优惠</span>
        </div>
        <div class="card-body">
          <div class="switch-row">
            <span class="switch-label">开启特批优惠</span>
            <van-switch v-model="form.isSpecialDiscount" @change="handleSpecialDiscount" />
          </div>
          <div class="select-row" v-if="form.isSpecialDiscount" @click="showReviewerPicker = true">
            <span class="select-label">审批人</span>
            <span class="select-value" :class="{ placeholder: !reviewerName }">
              {{ reviewerName || '请选择审批人' }}
            </span>
            <van-icon name="arrow" size="14" color="#c8c9cc" />
          </div>
        </div>
      </div>

      <!-- 支付信息 -->
      <div class="form-card">
        <div class="card-header">
          <span class="card-icon"><van-icon name="gold-coin-o" size="16" color="#1989fa" /></span>
          <span class="card-title">支付信息</span>
          <van-button size="small" type="primary" plain @click="addPayType">新增支付方式</van-button>
        </div>
        <div class="card-body">
          <div v-if="!form.payList?.length" class="empty-state small">
            <span>暂无支付方式，未收款订单可后续在列表中收款</span>
          </div>
          <div v-for="(pay, idx) in form.payList" :key="idx" class="pay-item">
            <div class="pay-item-header">
              <span class="pay-item-title">
                支付方式 {{ idx + 1 }}
                <van-tag v-if="isCallbackPayRow(pay)" size="medium" type="warning" plain>线上支付·不可修改</van-tag>
              </span>
              <van-icon v-if="!isCallbackPayRow(pay)" name="delete-o" size="16" color="#c8c9cc" @click="removePayType(idx)" />
            </div>
            <div class="select-row" @click="openPayTypePicker(idx)">
              <span class="select-label">支付类型</span>
              <span class="select-value" :class="{ placeholder: !pay.payType }">
                {{ getDictLabel(pay_type, pay.payType) || '请选择支付类型' }}
              </span>
              <van-icon name="arrow" size="14" color="#c8c9cc" />
            </div>
            <van-field label="支付金额" type="number" v-model="pay.payAmount" placeholder="0"
              :disabled="pay.payType === '93' || isCallbackPayRow(pay)" @change="realPayChange()" />
            <van-field label="流水/支付单号" v-model="pay.serialNumber" :disabled="isCallbackPayRow(pay)"
              :placeholder="Number(pay.payAmount) > 0 ? '实缴大于0时必填' : '选填'" />
          </div>
          <div class="pay-summary" v-if="form.payList?.length">
            <div class="summary-item">
              <span>实缴</span>
              <span class="summary-val">¥{{ form.realPay || 0 }}</span>
            </div>
            <div class="summary-item">
              <span>欠费</span>
              <span class="summary-val" :class="{ danger: form.arrearage > 0 }">¥{{ form.arrearage || 0 }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 其他信息 -->
      <div class="form-card">
        <div class="card-header">
          <span class="card-icon"><van-icon name="edit" size="16" color="#1989fa" /></span>
          <span class="card-title">其他信息</span>
        </div>
        <div class="card-body">
          <van-field label="建档费" type="number" v-model="form.filingAmount" placeholder="0" @change="refreshAmount" />
          <van-field label="教材费" type="number" v-model="form.textBookAmount" placeholder="0" @change="refreshAmount" />
        </div>
      </div>

      <!-- 订单信息 -->
      <div class="form-card">
        <div class="card-header">
          <span class="card-icon"><van-icon name="description" size="16" color="#1989fa" /></span>
          <span class="card-title">订单信息</span>
        </div>
        <div class="card-body">
          <div class="select-row readonly">
            <span class="select-label">所属公司</span>
            <span class="select-value">{{ getDictLabel(company_list, currentCompanyId) }}</span>
          </div>
          <div class="select-row" @click="showPlannerPicker = true">
            <span class="select-label required">所属规划师</span>
            <span class="select-value" :class="{ placeholder: !plannerName }">
              {{ plannerName || '请选择规划师' }}
            </span>
            <van-icon name="arrow" size="14" color="#c8c9cc" />
          </div>
          <div class="select-row" :class="{ readonly: isBosi }" @click="!isBosi && (showSchoolPicker = true)">
            <span class="select-label required">经办校区</span>
            <span class="select-value" :class="{ placeholder: !schoolName }">
              {{ schoolName || (isBosi ? '请先选择班级' : '请选择校区') }}
            </span>
            <van-icon v-if="!isBosi" name="arrow" size="14" color="#c8c9cc" />
          </div>
          <div class="select-row" @click="showSemesterPicker = true">
            <span class="select-label">学期</span>
            <span class="select-value" :class="{ placeholder: !form.semester }">
              {{ getDictLabel(semester_list, form.semester) || '请选择学期' }}
            </span>
            <van-icon name="arrow" size="14" color="#c8c9cc" />
          </div>
          <van-field label="合同号" v-model="form.contractNo" placeholder="请输入合同号（为空则系统生成）" />
          <van-field label="收据号" v-model="form.receiptNo" placeholder="请输入收据号（为空则系统生成）" />
          <div class="select-row" @click="showDatePicker = true">
            <span class="select-label">缴费日期</span>
            <span class="select-value" :class="{ placeholder: !form.payTime }">
              {{ form.payTime || '实缴大于0时必填' }}
            </span>
            <van-icon v-if="form.payTime" name="clear" size="14" color="#c8c9cc" @click.stop="form.payTime = undefined" />
            <van-icon v-else name="arrow" size="14" color="#c8c9cc" />
          </div>
          <div class="select-row" v-if="!showReferralInfo" @click="showReferralPicker = true">
            <span class="select-label">转介绍类型</span>
            <span class="select-value" :class="{ placeholder: !form.referralType }">
              {{ getDictLabel(referral_type, form.referralType) || '请选择' }}
            </span>
            <van-icon name="arrow" size="14" color="#c8c9cc" />
          </div>
          <div class="select-row" v-if="!showReferralInfo && form.referralType === 1" @click="showReferralPersonPicker = true">
            <span class="select-label">介绍人</span>
            <span class="select-value" :class="{ placeholder: !form.referralPerson }">
              {{ form.referralPerson || '请选择员工' }}
            </span>
            <van-icon name="arrow" size="14" color="#c8c9cc" />
          </div>
          <van-field
            v-if="!showReferralInfo && (form.referralType === 2 || form.referralType === 3)"
            label="介绍人"
            v-model="form.referralPerson"
            placeholder="请输入转介绍人姓名"
          />
          <div class="select-row" v-if="!showReferralInfo && form.referralType === 4" @click="showReferralStudentPicker = true">
            <span class="select-label">介绍人</span>
            <span class="select-value" :class="{ placeholder: !form.referralPerson }">
              {{ form.referralPerson || '请选择介绍人学员' }}
            </span>
            <van-icon name="arrow" size="14" color="#c8c9cc" />
          </div>
          <div class="select-row" v-if="!showReferralInfo" @click="showSourcePicker = true">
            <span class="select-label required">来源</span>
            <span class="select-value" :class="{ placeholder: !form.orderSource }">
              {{ getDictLabel(consultation_source, form.orderSource) || '请选择来源' }}
            </span>
            <van-icon name="arrow" size="14" color="#c8c9cc" />
          </div>
          <van-field label="备注" v-model="form.remark" type="textarea" rows="2" placeholder="请输入备注" />
        </div>
      </div>

      <!-- 附件 -->
      <div class="form-card">
        <div class="card-header">
          <span class="card-icon"><van-icon name="orders-o" size="16" color="#1989fa" /></span>
          <span class="card-title">上传附件</span>
        </div>
        <div class="card-body">
          <van-uploader
            v-model="annexList"
            :max-count="10"
            :after-read="afterRead"
            @delete="onAnnexDelete"
          />
        </div>
      </div>

      <div style="height: 20px;"></div>
    </div>

    <!-- 底部提交栏 -->
    <div class="bottom-bar">
      <div class="bottom-amount">
        <span class="amount-label">应收</span>
        <span class="amount-value">¥{{ form.shouldPay || 0 }}</span>
      </div>
      <van-button type="primary" class="submit-btn" :loading="submitting" @click="submit">
        {{ form.orderId ? '保存修改' : '提交订单' }}
      </van-button>
    </div>

    <!-- 学员选择 -->
    <StudentPicker v-model:show="showStudentPicker" @select="onStudentSelected" />
    <!-- 转介绍类型4（学员介绍）：介绍人学员选择 -->
    <StudentPicker v-model:show="showReferralStudentPicker" @select="onReferralStudentSelected" />

    <!-- 新增学员 -->
    <StudentCreatePopup v-model:show="showStudentCreate" @submit="onStudentCreateSubmit" />

    <!-- 课程选择：博尔思 -->
    <CoursePicker v-if="!isBosi" v-model:show="showCoursePicker" @select="onCourseSelected" />

    <!-- 班级选择：博思班课先选班级，由班级带出课程和校区 -->
    <SchedulePicker v-if="isBosi" v-model:show="showSchedulePicker" @select="onScheduleSelected" />

    <!-- 支付类型选择 -->
    <van-popup v-model:show="showPayTypePicker" position="bottom" round>
      <van-picker
        :columns="payTypeColumns"
        @confirm="onPayTypeConfirm"
        @cancel="showPayTypePicker = false"
        title="选择支付类型"
      />
    </van-popup>

    <!-- 规划师选择 -->
    <van-popup v-model:show="showPlannerPicker" position="bottom" round>
      <van-picker :columns="plannerColumns" @confirm="onPlannerConfirm" @cancel="showPlannerPicker = false" title="选择规划师" />
    </van-popup>

    <!-- 审批人选择 -->
    <van-popup v-model:show="showReviewerPicker" position="bottom" round>
      <van-picker :columns="reviewerColumns" @confirm="onReviewerConfirm" @cancel="showReviewerPicker = false" title="选择审批人" />
    </van-popup>

    <!-- 续费教师选择：教师列表已全量加载，本地搜索过滤 -->
    <van-popup v-model:show="showTeacherPicker" position="bottom" round :style="{height:'60%'}">
      <div class="picker-header">
        <span>选择续费教师</span>
        <van-icon name="cross" @click="showTeacherPicker = false" />
      </div>
      <van-search v-model="teacherKeyword" placeholder="搜索教师姓名" shape="round" />
      <div class="picker-list">
        <van-cell
          v-for="t in teacherFilteredList"
          :key="t.userId"
          :title="t.nickName"
          is-link
          @click="onTeacherCellClick(t)"
        />
        <van-empty v-if="!teacherFilteredList.length" description="未找到匹配教师" />
      </div>
    </van-popup>

    <!-- 校区选择 -->
    <van-popup v-model:show="showSchoolPicker" position="bottom" round>
      <van-picker :columns="schoolColumns" @confirm="onSchoolConfirm" @cancel="showSchoolPicker = false" title="选择校区" />
    </van-popup>

    <!-- 学期选择 -->
    <van-popup v-model:show="showSemesterPicker" position="bottom" round>
      <van-picker :columns="semesterColumns" @confirm="onSemesterConfirm" @cancel="showSemesterPicker = false" title="选择学期" />
    </van-popup>

    <!-- 转介绍类型 -->
    <van-popup v-model:show="showReferralPicker" position="bottom" round>
      <van-picker :columns="referralColumns" @confirm="onReferralConfirm" @cancel="showReferralPicker = false" title="选择转介绍类型" />
    </van-popup>

    <!-- 介绍人(员工) -->
    <van-popup v-model:show="showReferralPersonPicker" position="bottom" round :style="{height:'60%'}">
      <div class="picker-header">
        <span>选择员工</span>
        <van-icon name="cross" @click="showReferralPersonPicker = false" />
      </div>
      <van-search v-model="referralKeyword" placeholder="搜索员工" shape="round" @search="searchReferralUsers" @clear="searchReferralUsers" />
      <div class="picker-list">
        <van-cell
          v-for="u in referralUserList"
          :key="u.userId"
          :title="u.nickName"
          is-link
          @click="onReferralPersonConfirm(u)"
        />
      </div>
    </van-popup>

    <!-- 来源选择 -->
    <van-popup v-model:show="showSourcePicker" position="bottom" round>
      <van-picker :columns="sourceColumns" @confirm="onSourceConfirm" @cancel="showSourcePicker = false" title="选择来源" />
    </van-popup>

    <!-- 日期选择 -->
    <van-calendar v-model:show="showDatePicker" @confirm="onDateConfirm" :min-date="minDate" />

    <!-- 优惠券选择 -->
    <van-popup v-model:show="showVoucherPicker" position="bottom" round :style="{height:'60%'}">
      <div class="picker-header">
        <span>选择优惠券（最多{{ form.studyCourseList?.length || 0 }}张）</span>
        <van-icon name="cross" @click="showVoucherPicker = false" />
      </div>
      <div class="picker-list">
        <van-cell
          v-for="v in voucherList"
          :key="v.voucherNo"
          :title="v.activityName"
          :label="`¥${v.amount} | ${v.startDate}~${v.endDate}`"
          @click="toggleVoucher(v)"
        >
          <template #right-icon>
            <van-icon :name="isVoucherSelected(v.voucherNo) ? 'success' : 'circle'" :color="isVoucherSelected(v.voucherNo) ? '#1989fa' : '#c8c9cc'" />
          </template>
        </van-cell>
      </div>
    </van-popup>

    <!-- 欠费分摊弹窗 -->
    <van-popup v-model:show="arrearageDialogVisible" position="bottom" round :style="{height:'70%'}">
      <div class="picker-header">
        <span>欠费金额分摊</span>
      </div>
      <div class="arrearage-tip">为统计每个课程的实际收入，请设置本次欠费金额</div>
      <div class="arrearage-list">
        <div v-for="(course, idx) in arrearageCourseList" :key="idx" class="arrearage-item">
          <div class="arrearage-name">{{ course.courseName }}</div>
          <div class="arrearage-row">
            <span>应收 ¥{{ course.realPrice }}</span>
            <van-stepper
              v-model="course.tempArrearageAmount"
              :min="0"
              :max="course.realPrice"
              step="10"
              :precision="2"
            />
          </div>
          <div class="arrearage-paid">实缴 ¥{{ (course.realPrice - (course.tempArrearageAmount || 0)).toFixed(2) }}</div>
        </div>
      </div>
      <div class="arrearage-footer">
        <span>欠费总计：<b>¥{{ form.arrearage?.toFixed(2) }}</b></span>
        <span>待分配：<b :class="{ matched: pendingArrearage === 0 }">¥{{ pendingArrearage.toFixed(2) }}</b></span>
      </div>
      <div class="arrearage-actions">
        <van-button plain block @click="arrearageDialogVisible = false">取消</van-button>
        <van-button type="primary" block :disabled="pendingArrearage !== 0" @click="onArrearageConfirm">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { showSuccessToast, showFailToast, showLoadingToast, closeToast, showToast } from 'vant'
import { getOrder, addOrder, updateOrder } from '@/api/order'
import { getStudentList, addStudent } from '@/api/student'
import { getUserInfo } from '@/api/auth'
import { getSchoolDicts } from '@/api/dict'
import { getUserListByRoleKey, simpleListUser } from '@/api/user'
import { getAvailableMarketing } from '@/api/marketing'
import { getOrderAvailableVoucherList } from '@/api/voucher'
import { uploadFileH5 } from '@/api/oss'
import { useDict, selectDictLabel } from '@/utils/dict'
import { ensureWecomLogin } from '@/utils/wecomAuth'
import { BOSI_COMPANY_ID, getCurrentCompanyId, initializeCompanyContext } from '@/utils/company'
import { useOrderAmount } from './composables/useOrderAmount'
import { useMarketing } from './composables/useMarketing'
import StudentPicker from './components/StudentPicker.vue'
import StudentCreatePopup from '../crm/components/StudentCreatePopup.vue'
import CoursePicker from './components/CoursePicker.vue'
import SchedulePicker from './components/SchedulePicker.vue'

const route = useRoute()
const router = useRouter()

const {
  grade_list, semester_list, company_list, referral_type, consultation_source, pay_type, order_type,
  class_level, class_number, periods_class
} = useDict('grade_list', 'semester_list', 'company_list', 'referral_type', 'consultation_source', 'pay_type', 'order_type', 'class_level', 'class_number', 'periods_class')

// 字典label
function getDictLabel(dict, value) {
  return selectDictLabel(dict, value)
}

// 班号/期数/层次：字典查不到时回退原始值，避免显示 '-'
function safeDictLabel(dict, value) {
  if (value === undefined || value === null || value === '') return ''
  const label = selectDictLabel(dict, value)
  return label === '-' ? value : label
}

// 表单数据
const initForm = () => ({
  orderId: undefined,
  studentId: undefined,
  studentName: undefined,
  grade: undefined,
  receiptNo: undefined,
  schoolId: undefined,
  type: undefined,
  shouldPay: undefined,
  courseAmount: 0,
  realPay: undefined,
  arrearage: 0,
  contractNo: undefined,
  payTime: undefined,
  remark: undefined,
  isOvercharging: 0,
  overchargingAmount: undefined,
  classHourTotal: undefined,
  preferentialAmount: 0,
  isSpecialDiscount: 0,
  textBookAmount: 0,
  filingAmount: 0,
  referralPerson: undefined,
  referralStudentId: undefined,
  referralAmount: 0,
  plannerId: undefined,
  semester: undefined,
  orderSource: undefined,
  referralType: undefined,
  reviewer: undefined,
  payList: [],
  studyCourseList: [],
  selectDiscountCard: [],
  selectReductionCard: [],
  selectGiftCard: [],
  selectVoucher: [],
  annex: []
})

const form = ref(initForm())
const checkedStudent = ref(null)
const submitting = ref(false)
const minDate = new Date(2020, 0, 1)

// 基础数据
const schoolList = ref([])
const plannerList = ref([])
const teacherList = ref([])
const reviewerList = ref([])
const marketingData = ref({})
const voucherList = ref([])
const referralUserList = ref([])
const referralKeyword = ref('')
const teacherKeyword = ref('')
const annexList = ref([])

// 选择器状态
const showStudentPicker = ref(false)
const showStudentCreate = ref(false)
const showReferralStudentPicker = ref(false)
const showCoursePicker = ref(false)
const showSchedulePicker = ref(false)
const showPayTypePicker = ref(false)
const showPlannerPicker = ref(false)
const showReviewerPicker = ref(false)
const showTeacherPicker = ref(false)
const currentTeacherCourseIdx = ref(-1)
const showSchoolPicker = ref(false)
const showSemesterPicker = ref(false)
const showReferralPicker = ref(false)
const showReferralPersonPicker = ref(false)
const showSourcePicker = ref(false)
const showDatePicker = ref(false)
const showVoucherPicker = ref(false)
const currentPayIndex = ref(0)

// 欠费分摊
const arrearageDialogVisible = ref(false)
const arrearageCourseList = ref([])

// 共享Maps
const maxReductionAmount = new Map()
const maxGiftHour = new Map()

let marketingComposable = null

const amountComposable = useOrderAmount(
  form,
  maxReductionAmount,
  maxGiftHour,
  () => marketingComposable?.refreshAvailableMarketing()
)

const {
  refreshAmount, realPayChange, buyNumbersChange, updateOrderCourseData,
  reductionAmountChange, discountChange, giftClassHourCountChange
} = amountComposable

marketingComposable = useMarketing(
  form, marketingData, refreshAmount, reviewerList, maxReductionAmount, maxGiftHour
)

const {
  discountAvailableMarketing, reductionAvailableMarketing, giftAvailableMarketing,
  editDiscount, initAvailableMarketing, initSelectCards,
  handleDiscountCardSelect, handleReductionCardSelect, handleGiftCardSelect,
  handleSpecialDiscount, isCheckedCards
} = marketingComposable

// 公司上下文：H5 不支持“全部公司”，博思班课按班级优先录入
const currentCompanyId = ref(getCurrentCompanyId())
const isBosi = computed(() => currentCompanyId.value === BOSI_COMPANY_ID)

// 计算属性
const schoolName = computed(() => {
  const s = schoolList.value.find(s => s.schoolId === form.value.schoolId)
  return s?.schoolName || ''
})
const plannerName = computed(() => {
  const p = plannerList.value.find(p => p.userId === form.value.plannerId)
  return p?.nickName || ''
})
const reviewerName = computed(() => {
  const r = reviewerList.value.find(r => r.userId === form.value.reviewer)
  return r?.nickName || ''
})
// 对齐PC端「仅含新签(paymentType=1)课程的订单可填转介绍」（PC：无新签课程时 select 禁用并清空介绍人/学员/金额）：
// 有新签课程 → 显示来源(必填)与转介绍信息；纯续费/扩科 → 隐藏来源，转介绍不可填
const showReferralInfo = computed(() => {
  return !(form.value.studyCourseList?.some(course => Number(course.paymentType) === 1) || false)
})
// 课程变化后无新签（纯续费/扩科）时，清空已填的转介绍信息（对齐PC端清空逻辑；不监听 immediate，避免回显存量数据被误清）
watch(showReferralInfo, (noNewSign) => {
  if (noNewSign) {
    form.value.referralType = undefined
    form.value.referralPerson = undefined
    form.value.referralStudentId = undefined
    form.value.referralAmount = undefined
  }
})

// Picker columns
// 回调写入的支付类型（系统微信90/数币91/富友微信95/富友支付宝96）：
// 数据来自支付回调，金额与流水号精准不可改，禁止手动选择、修改、删除
const CALLBACK_PAY_TYPES = ['90', '91', '95', '96']
function isCallbackPayRow(pay) {
  return CALLBACK_PAY_TYPES.includes(String(pay?.payType))
}
const payTypeColumns = computed(() => (pay_type.value || [])
  .filter(d => !CALLBACK_PAY_TYPES.includes(String(d.dictValue)))
  .map(d => ({ text: d.dictLabel, value: d.dictValue })))
const plannerColumns = computed(() => plannerList.value.map(u => ({ text: u.nickName, value: u.userId })))
const reviewerColumns = computed(() => reviewerList.value.map(u => ({ text: u.nickName, value: u.userId })))
// 续费教师弹窗：列表已全量加载，本地按姓名过滤
const teacherFilteredList = computed(() => {
  const kw = (teacherKeyword.value || '').trim()
  const list = teacherList.value || []
  return kw ? list.filter(t => (t.nickName || '').includes(kw)) : list
})
const schoolColumns = computed(() => schoolList.value.map(s => ({ text: s.schoolName, value: s.schoolId })))
const semesterColumns = computed(() => (semester_list.value || []).map(d => ({ text: d.dictLabel, value: d.dictValue })))
const referralColumns = computed(() => (referral_type.value || []).map(d => ({ text: d.dictLabel, value: parseInt(d.dictValue) })))
const sourceColumns = computed(() => (consultation_source.value || []).map(d => ({ text: d.dictLabel, value: d.dictValue })))

// 欠费分摊
const pendingArrearage = computed(() => {
  const total = arrearageCourseList.value.reduce((acc, c) => acc + (c.tempArrearageAmount || 0), 0)
  return +(form.value.arrearage - total).toFixed(2)
})

onMounted(async () => {
  await ensureWecomLogin(route.query.code)
  const userInfoResponse = await getUserInfo()
  initializeCompanyContext(userInfoResponse)
  currentCompanyId.value = getCurrentCompanyId()
  await Promise.all([
    loadSchools(),
    loadPlanners(),
    loadTeachers(),
    loadReviewers(),
    loadMarketing(),
    loadVouchers()
  ])
  // 新建订单：经办校区默认选第一个（编辑订单以回显为准不覆盖；博思班课选班级时校区由班级带出覆盖）
  if (!route.query.id && !form.value.schoolId && schoolList.value.length) {
    form.value.schoolId = schoolList.value[0].schoolId
  }
  if (route.query.id) {
    await loadOrderDetail(route.query.id)
  }
})

async function loadSchools() {
  try {
    const res = await getSchoolDicts()
    schoolList.value = res || []
  } catch (e) { schoolList.value = [] }
}

async function loadPlanners() {
  try {
    const res = await getUserListByRoleKey('planner')
    plannerList.value = res || []
  } catch (e) { plannerList.value = [] }
}

async function loadReviewers() {
  try {
    const res = await getUserListByRoleKey('specialDiscountReviewer')
    reviewerList.value = res || []
  } catch (e) { reviewerList.value = [] }
}
async function loadTeachers() {
  try {
    const res = await getUserListByRoleKey('teacher')
    teacherList.value = res || []
  } catch (e) { teacherList.value = [] }
}

async function loadMarketing() {
  try {
    const res = await getAvailableMarketing()
    marketingData.value = res || {}
  } catch (e) { marketingData.value = {} }
}

async function loadVouchers() {
  try {
    const res = await getOrderAvailableVoucherList({ orderId: route.query.id })
    voucherList.value = res || []
  } catch (e) { voucherList.value = [] }
}

async function loadOrderDetail(id) {
  try {
    const res = await getOrder(id)
    let data = res || {}
    // 处理课程数据
    data.studyCourseList?.forEach(k => {
      if (data.isSpecialDiscount) {
        k.editGiftClassHourCount = true
        k.editReductionAmount = true
      }
      if (data.voucherNos) k.editReductionAmount = true
    })
    if (data.payList) {
      data.payList.forEach(k => { k.payType = String(k.payType) })
    }
    form.value = { ...initForm(), ...data }
    form.value.selectVoucher = data.voucherNos ? data.voucherNos.split(',') : []
    checkedStudent.value = {
      grade: data.studentGrade,
      schoolName: data.studentSchoolName,
      studentNo: data.studentNo,
      accountBalance: data.accountBalance,
      subjects: data.subjects
    }
    // 附件：回显预览列表与 form.annex（ossId 数组）同步构建
    if (data.annexVoList) {
      annexList.value = data.annexVoList.map(a => ({ url: a.url, ossId: String(a.ossId), status: 'done' }))
      form.value.annex = data.annexVoList.map(a => String(a.ossId))
    } else {
      annexList.value = []
      form.value.annex = []
    }
    if (data.isSpecialDiscount) {
      editDiscount.value = true
    } else {
      initAvailableMarketing()
      initSelectCards(data.orderMarketingMap)
    }
    refreshAmount()
  } catch (e) {
    showFailToast('加载订单失败')
  }
}

// 学员选择
function onStudentSelected(student) {
  form.value.studentName = student.studentName
  form.value.studentId = student.studentId
  form.value.grade = student.grade
  form.value.plannerId = student.plannerId
  checkedStudent.value = student
}

// 新增学员提交：归属当前公司，成功后拉取完整标签数据并自动选中
async function onStudentCreateSubmit(payload) {
  try {
    showLoadingToast({ message: '创建中...', forbidClick: true, duration: 0 })
    const created = await addStudent({ ...payload, companyId: getCurrentCompanyId() })
    // 拉取完整学员信息（含校区名/学号等标签数据），失败则降级用创建返回值
    let student = created
    try {
      const rows = await getStudentList({ pageNum: 1, pageSize: 20, studentName: payload.studentName })
      const match = (rows || []).find(s => s.studentId === created.studentId)
      if (match) student = match
    } catch (e) { /* 忽略，用创建返回值回填 */ }
    closeToast()
    showStudentCreate.value = false
    showToast(created.tipMessage || '学员创建成功')
    onStudentSelected(student)
  } catch (e) {
    closeToast()
    showToast(e?.message || '创建失败')
  }
}

// 博思班课：先选班级，课程和校区由班级带出
function onScheduleSelected(schedule) {
  if (form.value.studyCourseList?.some(c => c.scheduleId === schedule.scheduleId)) {
    showFailToast('该班级已添加')
    return
  }

  const newCourse = {
    ...schedule,
    buyNumbers: 1,
    buyClassHourCount: schedule.classHourCount,
    giftClassHourCount: 0,
    reductionAmount: 0,
    discount: 100,
    coursePay: schedule.totalPrice,
    realPrice: schedule.totalPrice,
    paymentType: 1,
    editReductionAmount: !!form.value.isSpecialDiscount,
    editGiftClassHourCount: !!form.value.isSpecialDiscount
  }
  form.value.studyCourseList?.push(newCourse)
  form.value.schoolId = schedule.schoolId
  updateOrderCourseData()
  showSchedulePicker.value = false
}

// 课程选择
function onCourseSelected(course) {
  // 检查是否已选
  if (form.value.studyCourseList?.some(c => c.courseId === course.courseId)) {
    showFailToast('该课程已添加')
    return
  }
  // 缴费类型自动判断：根据学员已购买科目（与PC端一致）
  // 学员无已购科目→新报(1)，已购该科目→续费(2)，已购其他科目→扩科(4)
  let paymentType = 1
  const subjects = checkedStudent.value?.subjects
  if (subjects) {
    const subjectsArray = subjects.split(',').filter(Boolean)
    if (subjectsArray.length > 0) {
      paymentType = subjectsArray.includes(String(course.subject)) ? 2 : 4
    }
  }
  const newCourse = {
    ...course,
    buyNumbers: 1,
    buyClassHourCount: course.classHourCount,
    giftClassHourCount: 0,
    reductionAmount: 0,
    discount: 100,
    coursePay: course.totalPrice,
    realPrice: course.totalPrice,
    paymentType,
    editReductionAmount: !!form.value.isSpecialDiscount,
    editGiftClassHourCount: !!form.value.isSpecialDiscount
  }
  form.value.studyCourseList?.push(newCourse)
  updateOrderCourseData()
  showCoursePicker.value = false
}

// 续费/扩科是否可编辑（对齐PC端：paymentType为2/4且teachingModel!==99）
function isRenewalEditable(course) {
  if (!course.paymentType) return false
  return [2, 4].includes(course.paymentType) && course.teachingModel !== 99
}

// 缴费类型胶囊切换：切换后同步续费教师/续费金额的联动清理（对齐PC端handlePaymentTypeChange）
function onPaymentTypeTabClick(course, value) {
  course.paymentType = value
  handlePaymentTypeChange(course)
}

// 切换缴费类型（对齐PC端handlePaymentTypeChange）
function handlePaymentTypeChange(course) {
  if (!isRenewalEditable(course)) {
    course.teacherId = undefined
    course.commissionAmount = undefined
  } else {
    course.commissionAmount = course.realPrice
  }
}

// 续费金额变更：不能超过优惠后金额
function handleCommissionAmountChange(course) {
  if (course.commissionAmount > course.realPrice) {
    course.commissionAmount = course.realPrice
  }
}

// 续费教师选择
function openTeacherPicker(idx) {
  currentTeacherCourseIdx.value = idx
  teacherKeyword.value = ''
  showTeacherPicker.value = true
}
function onTeacherCellClick(teacher) {
  const course = form.value.studyCourseList?.[currentTeacherCourseIdx.value]
  if (course) {
    course.teacherId = teacher.userId
  }
  showTeacherPicker.value = false
}
function getTeacherName(userId) {
  const t = teacherList.value.find(t => t.userId === userId)
  return t?.nickName || ''
}

function removeCourse(idx) {
  form.value.studyCourseList?.splice(idx, 1)
  updateOrderCourseData()
}

// 课程字段变更
function onBuyNumbersChange(row) { buyNumbersChange(row) }
function onGiftChange(row) { giftClassHourCountChange(row) }
function onDiscountChange(row) { discountChange(row) }
function onReductionChange(row) { reductionAmountChange(row) }

// 营销政策
function isCardSelected(cards, card) {
  return isCheckedCards(cards, card)
}

// 优惠券
function isVoucherSelected(voucherNo) {
  return form.value.selectVoucher?.includes(voucherNo)
}
function toggleVoucher(voucher) {
  const idx = form.value.selectVoucher?.indexOf(voucher.voucherNo)
  if (idx > -1) {
    form.value.selectVoucher?.splice(idx, 1)
  } else {
    const max = form.value.studyCourseList?.length || 0
    if (form.value.selectVoucher.length >= max) {
      showFailToast(`最多选择${max}张优惠券`)
      return
    }
    form.value.selectVoucher?.push(voucher.voucherNo)
  }
  handleVoucherSelect()
}
function handleVoucherSelect() {
  if (!form.value.studyCourseList?.length) {
    showFailToast('请先选择课程')
    form.value.selectVoucher = []
    return
  }
  if (form.value.selectVoucher?.length > 0) {
    form.value.studyCourseList?.forEach(course => { course.editReductionAmount = true })
  } else {
    form.value.studyCourseList?.forEach(course => {
      course.editReductionAmount = false
    })
    if (maxReductionAmount) {
      maxReductionAmount.forEach((_v, key) => {
        form.value.studyCourseList?.forEach(row => {
          if (row.teachingType === key) row.editReductionAmount = true
        })
      })
    }
  }
  refreshAmount()
}

// 支付方式
function addPayType() {
  form.value.payList?.push({ payType: '1', serialNumber: '', payAmount: 0 })
}
function removePayType(idx) {
  const row = form.value.payList?.[idx]
  if (isCallbackPayRow(row)) return
  form.value.payList?.splice(idx, 1)
  realPayChange()
}
function openPayTypePicker(idx) {
  if (isCallbackPayRow(form.value.payList?.[idx])) return
  currentPayIndex.value = idx
  showPayTypePicker.value = true
}
function onPayTypeConfirm({ selectedOptions }) {
  form.value.payList[currentPayIndex.value].payType = selectedOptions[0]?.value
  showPayTypePicker.value = false
}

// Picker confirm handlers
function onPlannerConfirm({ selectedOptions }) { form.value.plannerId = selectedOptions[0]?.value; showPlannerPicker.value = false }
function onReviewerConfirm({ selectedOptions }) { form.value.reviewer = selectedOptions[0]?.value; showReviewerPicker.value = false }
function onSchoolConfirm({ selectedOptions }) { form.value.schoolId = selectedOptions[0]?.value; showSchoolPicker.value = false }
function onSemesterConfirm({ selectedOptions }) { form.value.semester = selectedOptions[0]?.value; showSemesterPicker.value = false }
function onReferralConfirm({ selectedOptions }) {
  form.value.referralType = selectedOptions[0]?.value
  form.value.referralPerson = undefined
  form.value.referralStudentId = undefined
  showReferralPicker.value = false
}
function onSourceConfirm({ selectedOptions }) { form.value.orderSource = selectedOptions[0]?.value; showSourcePicker.value = false }

// 转介绍类型4（学员介绍）：选择介绍人学员（对齐PC端 OrderStudent 选择器）
function onReferralStudentSelected(item) {
  form.value.referralPerson = item?.studentName
  form.value.referralStudentId = item?.studentId
  showReferralStudentPicker.value = false
}
function onDateConfirm(date) {
  form.value.payTime = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`
  showDatePicker.value = false
}

// 介绍人搜索（弹窗打开即加载员工列表，搜索/清空时按姓名过滤）
async function searchReferralUsers() {
  try {
    const res = await simpleListUser({ nickName: referralKeyword.value, pageNum: 1, pageSize: 50 })
    referralUserList.value = res?.rows || res || []
  } catch (e) { referralUserList.value = [] }
}
watch(showReferralPersonPicker, (val) => {
  if (val) {
    referralKeyword.value = ''
    searchReferralUsers()
  }
})
function onReferralPersonConfirm(user) {
  form.value.referralPerson = user.nickName
  showReferralPersonPicker.value = false
}

// 附件上传：后端 annex 存 ossId 逗号串，上传成功后记录 ossId
async function afterRead(file) {
  // 多选时 file 是数组，统一处理
  const files = Array.isArray(file) ? file : [file]
  for (const f of files) {
    if (!f.file) continue
    f.status = 'uploading'
    f.message = '上传中...'
    try {
      const formData = new FormData()
      formData.append('file', f.file)
      const res = await uploadFileH5(formData)
      if (!res?.ossId) {
        throw new Error('上传结果缺少ossId')
      }
      f.status = 'done'
      f.message = '上传成功'
      f.ossId = String(res.ossId)
      if (!form.value.annex) form.value.annex = []
      form.value.annex.push(f.ossId)
    } catch (e) {
      f.status = 'failed'
      f.message = '上传失败'
    }
  }
}
function onAnnexDelete(file) {
  // 按 ossId 匹配删除，避免失败项/回显项与 annexList 索引错位
  const ossId = file?.ossId
  if (!ossId || !form.value.annex) return
  const idx = form.value.annex.findIndex(id => String(id) === String(ossId))
  if (idx > -1) {
    form.value.annex.splice(idx, 1)
  }
}

// 欠费分摊
function onArrearageConfirm() {
  arrearageCourseList.value.forEach(ac => {
    const course = form.value.studyCourseList?.find(c => c.index === ac.index)
    if (course) course.arrearageAmount = ac.tempArrearageAmount
  })
  arrearageDialogVisible.value = false
  doSubmit()
}

// 提交
function submit() {
  realPayChange()
  // 校验
  if (!form.value.studentId) { showFailToast('请选择学员'); return }
  if (!form.value.studyCourseList?.length) { showFailToast('请选择课程'); return }
  if (!form.value.plannerId) { showFailToast('请选择规划师'); return }
  if (!form.value.schoolId) { showFailToast('请选择经办校区'); return }
  if (!showReferralInfo.value && !form.value.orderSource) { showFailToast('请选择来源'); return }

  // 支付校验：已填写支付金额时必须选缴费日期（对齐后端"非线上支付必须填写缴费日期"硬校验）
  const hasPayAmount = (form.value.payList || []).some(p => Number(p.payAmount) > 0)
  if (hasPayAmount && !form.value.payTime) { showFailToast('已填写支付金额，请选择缴费日期'); return }
  // 支付校验：已填写支付金额的行，流水/支付单号必填（对齐 PC 端"交易流水号为必填项"校验）
  if (hasPayAmount) {
    const noSerialRow = form.value.payList.find(p => Number(p.payAmount) > 0 && !(p.serialNumber || '').trim())
    if (noSerialRow) { showFailToast('已填写支付金额，请填写流水/支付单号'); return }
  }
  // 附件校验：有附件未上传完成（或上传失败）时不允许提交，避免丢附件
  const pendingAnnex = (annexList.value || []).some(f => f.status && f.status !== 'done')
  if (pendingAnnex) { showFailToast('附件上传中或上传失败，请等待完成或删除失败项'); return }

  // 课程校验
  if (isBosi.value) {
    const invalidSchedule = form.value.studyCourseList?.some(row => row.teachingModel === 99 && !row.scheduleId)
    if (invalidSchedule) { showFailToast('班课请选择相应班级'); return }
  }

  let hasError = false
  form.value.studyCourseList?.forEach(row => {
    if (!row.paymentType) { showFailToast('请选择课程缴费类型'); hasError = true; return }
    if (!row.reductionAmount) row.reductionAmount = 0
    if (row.realPrice < 0) { showFailToast('课程优惠后金额不能小于0'); hasError = true; return }
  })
  if (hasError) return

  // 优惠券校验
  if (form.value.selectVoucher?.length > 0) {
    const totalReduction = form.value.studyCourseList?.reduce((acc, c) => acc + (c.reductionAmount || 0), 0) || 0
    const selectedVouchers = voucherList.value.filter(v => form.value.selectVoucher.includes(v.voucherNo))
    const totalVoucher = selectedVouchers.reduce((acc, v) => acc + (v.amount || 0), 0)
    const maxReductionTotal = Array.from(maxReductionAmount.values()).reduce((acc, v) => acc + (v || 0), 0)
    const maxAvailable = maxReductionTotal + totalVoucher
    if (totalReduction > maxAvailable) {
      showFailToast('优惠金额不能超过最大可优惠金额')
      return
    }
  }

  // 欠费分摊
  if (form.value.arrearage > 0 && form.value.studyCourseList.length > 1) {
    arrearageCourseList.value = form.value.studyCourseList.map((course, idx) => ({
      ...course,
      index: idx,
      tempArrearageAmount: course.arrearageAmount || 0
    }))
    arrearageDialogVisible.value = true
    return
  }

  doSubmit()
}

async function doSubmit() {
  submitting.value = true
  try {
    const submitData = { ...form.value }
    submitData.textBookAmount = Number(submitData.textBookAmount || 0)
    submitData.filingAmount = Number(submitData.filingAmount || 0)
    submitData.overchargingAmount = submitData.overchargingAmount ?? 0
    submitData.arrearage = submitData.arrearage ?? 0
    // 支付方式：过滤掉金额为0的空行后回传。修改订单时必须回传已有支付数据——
    // 后端 updateBatch 为全删重插策略，不回传会把（含PC端录入的）支付方式全部清空
    submitData.payList = (form.value.payList || [])
      .filter(p => Number(p.payAmount) > 0)
      .map(p => ({ ...p, payAmount: Number(p.payAmount) }))
    // 附件：回传 ossId 逗号串（后端 OrderBo.annex / OrderDetail.annex 口径，与 PC 端一致）
    submitData.annex = (form.value.annex || []).filter(Boolean).join(',') || undefined

    if (form.value.orderId) {
      await updateOrder(submitData)
      showSuccessToast('修改成功')
    } else {
      await addOrder(submitData)
      showSuccessToast('新增成功')
    }
    // 标记列表需要刷新（列表页为 keep-alive 缓存，激活时据此刷新）
    sessionStorage.setItem('__orderListNeedRefresh', '1')
    router.back()
  } catch (e) {
    // 错误已由拦截器提示
  } finally {
    submitting.value = false
    arrearageDialogVisible.value = false
  }
}
</script>

<style scoped>
.order-form-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #f5f6f8;
  padding-bottom: 70px;
}

/* 内容区 */
.form-content {
  padding: 12px;
}

/* 卡片 */
.form-card {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 14px 16px 10px;
}
.card-icon {
  font-size: 16px;
}
.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #323233;
  flex: 1;
}

/* 必填标识 */
.required::before {
  content: '*';
  color: #ee0a24;
  margin-right: 2px;
}
.paytype-label {
  font-size: 13px;
  color: #646566;
  margin-bottom: 8px;
}
.card-body {
  padding: 0 16px 14px;
}

/* 选择行 */
.select-row {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f2f3f5;
  cursor: pointer;
}
.select-row:last-child {
  border-bottom: none;
}
.select-label {
  font-size: 14px;
  color: #646566;
  width: 80px;
  flex-shrink: 0;
}
.select-value {
  flex: 1;
  font-size: 14px;
  color: #323233;
  text-align: right;
  margin-right: 6px;
}
.select-value.placeholder {
  color: #c8c9cc;
}

/* 学员标签 */
.student-tags {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  padding-top: 10px;
}
.student-tags .balance {
  font-size: 12px;
  color: #ee0a24;
  margin-left: auto;
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px 0;
  color: #c8c9cc;
  font-size: 13px;
}
.empty-state.small {
  padding: 16px 0;
}

/* 课程卡片 */
.course-card {
  background: #f7f8fa;
  border: 1px solid #eef0f3;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 10px;
}
.course-card:last-child {
  margin-bottom: 0;
}
.course-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #eef0f3;
}
.course-name {
  font-size: 14px;
  font-weight: 600;
  color: #323233;
}
.course-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 10px;
}
/* 信息项统一白底圆角小块：网格同行等高拉伸，左右基线自动对齐 */
.info-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  background: #fff;
  border: 1px solid #eef0f3;
  border-radius: 8px;
  padding: 8px 10px;
}
.info-label {
  font-size: 12px;
  color: #969799;
}
.info-value {
  font-size: 14px;
  color: #323233;
  font-weight: 600;
}

/* 缴费类型胶囊按钮组：等宽平铺，避免5个挤在一行左右不齐 */
.payment-type-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}
.payment-tab {
  flex: 1 1 0;
  min-width: 52px;
  text-align: center;
  padding: 5px 4px;
  font-size: 12px;
  color: #646566;
  background: #fff;
  border: 1px solid #e2e5ea;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.15s;
}
.payment-tab.active {
  color: #fff;
  background: #1989fa;
  border-color: #1989fa;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(25, 137, 250, 0.25);
}

/* 课程金额行 */
.course-amount-row {
  display: flex;
  gap: 12px;
  padding-top: 10px;
  border-top: 1px solid #ebedf0;
}
.amount-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.amount-label {
  font-size: 12px;
  color: #969799;
}
.amount-value {
  font-size: 15px;
  color: #323233;
  font-weight: 600;
}
.amount-highlight .amount-value {
  color: #1989fa;
}

/* 续费教师/续费金额：细边框浅蓝面板（无左侧竖条），置于课程信息之后 */
.renewal-section {
  background: #f5f9ff;
  border: 1px solid #d8e8ff;
  border-radius: 8px;
  padding: 2px 12px;
  margin-bottom: 0;
  margin-top: 10px;
}
.renewal-section .select-row {
  padding: 10px 0;
  border-bottom: 1px dashed #e0edff;
}
.renewal-section .select-row:last-child {
  border-bottom: none;
}
.renewal-section .select-label,
.renewal-amount-row .select-label {
  font-size: 13px;
  color: #646566;
}
.renewal-amount-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

/* 金额汇总 */
.amount-summary {
  display: flex;
  justify-content: space-around;
  padding-top: 12px;
  margin-top: 10px;
  border-top: 1px dashed #ebedf0;
}
.summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.summary-item span:first-child {
  font-size: 12px;
  color: #969799;
}
.summary-val {
  font-size: 15px;
  font-weight: 600;
  color: #323233;
}
.summary-val.highlight {
  color: #1989fa;
}
.summary-val.danger {
  color: #ee0a24;
}
.summary-val.warning {
  color: #ff976a;
}

/* 营销政策 */
.policy-group {
  margin-bottom: 12px;
}
.policy-group:last-child {
  margin-bottom: 0;
}
.policy-label {
  font-size: 13px;
  color: #969799;
  margin-bottom: 8px;
}
.policy-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.policy-chip {
  padding: 8px 12px;
  background: #f7f8fa;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  min-width: 100px;
}
.policy-chip.active {
  background: #e8f3ff;
  border-color: #1989fa;
}
.chip-name {
  font-size: 13px;
  font-weight: 500;
  color: #323233;
  margin-bottom: 2px;
}
.policy-chip.active .chip-name {
  color: #1989fa;
}
.chip-desc {
  font-size: 11px;
  color: #969799;
}

/* 开关行 */
.switch-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
}
.switch-label {
  font-size: 14px;
  color: #323233;
}

/* 支付信息 */
.pay-amount-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: #f7f8fa;
  border-radius: 8px;
  margin-bottom: 10px;
}
.pay-discount {
  font-size: 12px;
  color: #07c160;
}
.pay-should {
  font-size: 16px;
  font-weight: 700;
  color: #ee0a24;
}
.pay-item {
  background: #f7f8fa;
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 10px;
}
.pay-item:last-child {
  margin-bottom: 0;
}
.pay-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.pay-item-title {
  font-size: 13px;
  font-weight: 600;
  color: #646566;
}
.pay-summary {
  display: flex;
  justify-content: space-around;
  padding-top: 12px;
  margin-top: 10px;
  border-top: 1px dashed #ebedf0;
}

/* 底部栏 */
.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 10px 16px calc(10px + constant(safe-area-inset-bottom));
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #ebedf0;
  z-index: 99;
}
.bottom-amount {
  flex: 1;
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.amount-label {
  font-size: 13px;
  color: #969799;
}
.amount-value {
  font-size: 20px;
  font-weight: 700;
  color: #ee0a24;
}
.submit-btn {
  width: 140px !important;
  height: 42px !important;
}

/* 弹窗通用 */
.picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #f2f3f5;
}
.picker-list {
  max-height: calc(60vh - 100px);
  overflow-y: auto;
}

/* 欠费分摊 */
.arrearage-tip {
  padding: 10px 16px;
  font-size: 13px;
  color: #969799;
  background: #f7f8fa;
}
.arrearage-list {
  padding: 0 16px;
  max-height: 40vh;
  overflow-y: auto;
}
.arrearage-item {
  padding: 12px 0;
  border-bottom: 1px solid #f2f3f5;
}
.arrearage-item:last-child {
  border-bottom: none;
}
.arrearage-name {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
}
.arrearage-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #646566;
}
.arrearage-paid {
  font-size: 12px;
  color: #07c160;
  margin-top: 4px;
}
.arrearage-footer {
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 14px;
  border-top: 1px solid #f2f3f5;
  background: #fafafa;
}
.arrearage-footer .matched {
  color: #07c160;
}
.arrearage-actions {
  display: flex;
  gap: 10px;
  padding: 10px 16px calc(10px + constant(safe-area-inset-bottom));
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
}
.arrearage-actions .van-button {
  flex: 1;
}

/* van-field label 与 select-row label 对齐、颜色一致 */
.order-form-page :deep(.van-field) {
  padding: 12px 0;
}
.order-form-page :deep(.van-field__label) {
  width: 80px;
  margin-right: 0;
  flex-shrink: 0;
  color: #646566;
  font-size: 14px;
}
</style>
